import { Box, Button, Dialog, DialogContent, DialogTitle, FormControlLabel, Grid, Switch } from '@mui/material';
import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../contexts/GlobalContext';
import { String } from '../utils/Helper';

function NotificationPreferences({setLoading, Wrapper}) {
    const { url,  contact, token, portal } = useContext(GlobalContext);
    const [preferences, setPreferences] = useState({});
    const [open, setOpen] = useState(false);
    const [hasDeviceNotificationPermission, setHasDeviceNotificationPermission] = useState(false);
    const [hasAnyRsonsNotificationPermission, setHasAnyRsonsNotificationPermission] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleSubmit = function(event){
        event.preventDefault();
        setLoading(true);
        
        let devicePreferences = JSON.parse(localStorage.getItem(`preferences`) || "{}");
        devicePreferences = {
            ...devicePreferences,
            [contact]: {
                ...(devicePreferences?.[contact] || {}),
                [portal]: {
                    ...(devicePreferences?.[contact]?.[portal] || {}),
                    notifications: Object.keys(preferences).filter((key) => preferences[key].value)
                }
            }
        }
        localStorage.setItem(`preferences`, JSON.stringify(devicePreferences));

        axios.post(
                `${url}api/set-notification-preferences`,
                { device_token: localStorage.getItem('device_token'), preferences: {contact, portal, notifications: devicePreferences[contact][portal]['notifications']} },
                { headers: { Authorization: `Bearer ${token}` }}
            )
           .then((res) => {
                if (res.data.error) throw new Error(res.data.message);
                return res.data;
            })
           .then((res) => {
                console.log(res);
            })
            .catch((err) => {
                console.log(err);
           })
           .finally(() => setLoading(false));
    }

    const fetchAvailableAndSetPreferences = async function(){
        const deviceNotificationPreferences = JSON.parse(localStorage.getItem(`preferences`) || "{}")?.[contact]?.[portal]?.['notifications'] || [];
        return await axios.post(`${url}api/available-notifications`,{contact, portal}, { headers: { Authorization: `Bearer ${token}` }})
            .then((res) => {
                if (res.data.error) throw new Error(res.data.message);
                return res.data.available_notifications;
            })
            .then((availableNotifications) => {
                const preferencesTemp = Object.fromEntries(
                    availableNotifications.map((notification) => {
                        return [notification, {
                            key: notification,
                            label: String.toTitleCase(notification),
                            value: deviceNotificationPreferences.includes(notification) || false
                        }];
                    })
                );
                setPreferences(preferencesTemp);
                return preferencesTemp;
            })
            .catch((err) => {
                console.log(err);
           });
    }

    useEffect(() => {
        (async() => {
            const preferences = await fetchAvailableAndSetPreferences();
            console.log(preferences);
            if (Object.keys(preferences).length !== 0){
                setHasAnyRsonsNotificationPermission(true);

                if (window.cordova){
                    window.cordova.plugins.notification.local.hasPermission( (granted) =>  granted ? setHasDeviceNotificationPermission(true) : '' );
                    return;
                }

                console.log("noty device permission", Notification.permission);
                if (Notification.permission === 'granted') setHasDeviceNotificationPermission(true);
            }

        })()
    }, []);

    if (hasAnyRsonsNotificationPermission === false) return (<></>);

    return (
        <>
            <Wrapper>
                {
                    !hasDeviceNotificationPermission
                    ? (
                        <Box sx={{ mb: 3 }}>
                            <p>Please allow notifications from this app to receive notifications from Rasiklal Sons.</p>
                        </Box>
                    )
                    : <Button variant="contained" onClick={handleOpen}>Manage Notification Preferences</Button>
                }
            </Wrapper>
            <Dialog onClose={handleClose} open={open}>
                <DialogTitle>Notification Preferences</DialogTitle>
                <DialogContent sx={{ width: '80vw', maxWidth: '500px' }}>
                    <form onSubmit={handleSubmit}>
                        { 
                            Object.keys(preferences).map((key) => (
                                <Grid key={key} item xs={6} sx={{ mb: 2 }}>
                                    <Preference id={key} preference={preferences[key]} setPreferences={setPreferences} /> 
                                </Grid>
                            )) 
                        }

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2 }}>
                            <Button type="submit" variant="contained">Save</Button>
                        </Box>
                    </form>
                </DialogContent>
            </Dialog>
        </>
    )
}

function Preference({preference, setPreferences}){
    const handleChange = (event) => { 
        event.stopPropagation(); 
        setPreferences((preferences) => {
            preferences[preference.key]['value'] = event.target.checked;
            return {...preferences};
        });
    }

    return ( <FormControlLabel componentsProps={{ typography: { variant: 'caption' } }} control={<Switch checked={preference.value} onChange={handleChange} />} label={preference.label} /> );
}

export default NotificationPreferences